(function($) {
	const setHeightOfSlideTrack = ($track, $slides) => {
		let height = 0;

		//first lets reset the heigh of the parent
		$track.css('height', '');

		//let's get all the visible ones and get the tallest
		$.each($slides, (i, el) =>  { 
			if($(el).outerHeight(true) > height){
				height = $(el).outerHeight(true);
			}
		});

		//set the height of the track to the tallest
		$track.css('height', height + 'px');
	}

	$.fn.frSplideResizeHeightOfSlider = function(splideInstance) {
		const $root = $(splideInstance.root);
		const $track = $root.find('> .splide__track');
		const $slides = $track.find('> .splide__list > .splide__slide:not(.splide__slide--clone)');

		splideInstance.on('resized', () => {
			setHeightOfSlideTrack($track, $slides.filter('.is-visible'));
		});

		splideInstance.on('ready', () => {
			setHeightOfSlideTrack($track, $slides.filter('.is-visible'));
		});

		splideInstance.on('move', (newIndex, prevIndex, destIndex) => {
			//all slides that aren't clones
			const slides = splideInstance.Components.Slides.get(true);

			$.each(slides, (i, el) =>  { 
				if(el.index === newIndex){
					setHeightOfSlideTrack($track, $(el.slide));
				}
			});
		});
	};
})(jQuery);